import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../views/theming/AppColors.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  toList3jhuyej2anx2q as toList,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  DismissibleHandler1ifn4mn1pfh06 as DismissibleHandler,
  dismissible3oiauji9y5bdb as dismissible,
  notificationBar4efejtg2792g as notificationBar,
  NotificationBarSemanticwa6jjp0en36y as NotificationBarSemantic,
} from '../views/theming/banners.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../views/theming/Titles.mjs';
import { html1nvxkcfsy8qu3 as html } from './utils.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  forEachAnimated1m511890zq8f5 as forEachAnimated,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var Type_Info_instance;
var Type_Warning_instance;
var Type_Danger_instance;
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_Info_instance = Type().pfz('Info', 0, AppColors_getInstance().jfz_1);
  Type_Warning_instance = Type().pfz('Warning', 1, AppColors_getInstance().ifz_1);
  Type_Danger_instance = Type().pfz('Danger', 2, AppColors_getInstance().hfz_1);
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      static pfz(name, ordinal, color) {
        var $this = this.c4(name, ordinal);
        $this.ofz_1 = color;
        return $this;
      }
    }
    initMetadataForClass($, 'Type');
    TypeClass = $;
  }
  return TypeClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      qfz(name, message) {
        return new (Banner())(name, Type_Info_getInstance(), message);
      }
      rfz(name, message) {
        return new (Banner())(name, Type_Warning_getInstance(), message);
      }
      sfz(name, message) {
        return new (Banner())(name, Type_Danger_getInstance(), message);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.tfz_1 = ArrayList().w();
      }
      ufz(name, message) {
        this.tfz_1.v(Companion_instance.qfz(name, message));
      }
      vfz(name, message) {
        this.tfz_1.v(Companion_instance.rfz(name, message));
      }
      wfz(name, message) {
        this.tfz_1.v(Companion_instance.sfz(name, message));
      }
      xfz(name, message) {
        return this.ufz(name, ($this$info) => message);
      }
      yfz(name, message) {
        return this.vfz(name, ($this$warn) => message);
      }
      zfz(name, message) {
        return this.wfz(name, ($this$danger) => message);
      }
      ag0(message) {
        // Inline function 'kotlin.let' call
        var tmp$ret$1 = take(message, 10) + getStringHashCode(message);
        return this.xfz(tmp$ret$1, message);
      }
      bg0(message) {
        // Inline function 'kotlin.let' call
        var tmp$ret$1 = take(message, 10) + getStringHashCode(message);
        return this.yfz(tmp$ret$1, message);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
function Type_Info_getInstance() {
  Type_initEntries();
  return Type_Info_instance;
}
function Type_Warning_getInstance() {
  Type_initEntries();
  return Type_Warning_instance;
}
function Type_Danger_getInstance() {
  Type_initEntries();
  return Type_Danger_instance;
}
var BannerClass;
function Banner() {
  if (BannerClass === VOID) {
    class $ {
      constructor(name, type, message) {
        this.cg0_1 = name;
        this.dg0_1 = type;
        this.eg0_1 = message;
      }
      fg0() {
        return this.dg0_1.ofz_1;
      }
      toString() {
        return 'Banner(name=' + this.cg0_1 + ', type=' + this.dg0_1.toString() + ', message=' + toString(this.eg0_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.cg0_1);
        result = imul(result, 31) + this.dg0_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.eg0_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Banner()))
          return false;
        if (!(this.cg0_1 === other.cg0_1))
          return false;
        if (!this.dg0_1.equals(other.dg0_1))
          return false;
        if (!equals(this.eg0_1, other.eg0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Banner');
    BannerClass = $;
  }
  return BannerClass;
}
function banners(setup) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (Builder())();
  setup(this_0);
  return toList(this_0.tfz_1);
}
function renderBanners(_this__u8e3s4, banners) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = renderBanners$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
  var _iterator__ex2g4s = sortedWith(banners, tmp$ret$0).m1();
  while (_iterator__ex2g4s.n1()) {
    var banner = _iterator__ex2g4s.o1();
    var tmp_0 = _Constant___init__impl__v45mub(new (DismissibleHandler())(banner.cg0_1));
    dismissible(view, new (Constant())(tmp_0), renderBanners$lambda_0(banner));
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderBannersNonDismissable(_this__u8e3s4, banners) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = renderBannersNonDismissable$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0_0())(tmp);
  var _iterator__ex2g4s = sortedWith(banners, tmp$ret$0).m1();
  while (_iterator__ex2g4s.n1()) {
    var banner = _iterator__ex2g4s.o1();
    var tmp_0 = notificationBar(view, banner.fg0());
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
    html(view_0, renderBannersNonDismissable$lambda_0(banner));
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderBanners_0(_this__u8e3s4, banners, hideWhenEmpty, animate) {
  hideWhenEmpty = hideWhenEmpty === VOID ? true : hideWhenEmpty;
  animate = animate === VOID ? false : animate;
  if (hideWhenEmpty) {
    shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownWhen.baj(banners).i1();
    });
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var sorted = lens(banners, renderBanners$lambda_1);
  if (animate) {
    forEachAnimated(view, sorted, VOID, renderBanners$lambda_2);
  } else {
    var tmp = lens(banners, renderBanners$lambda_3);
    forEachUpdating(view, tmp, 1, renderBanners$lambda_4);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderBanners_1(_this__u8e3s4, hideWhenEmpty, animate, banners) {
  hideWhenEmpty = hideWhenEmpty === VOID ? true : hideWhenEmpty;
  animate = animate === VOID ? false : animate;
  return renderBanners_0(_this__u8e3s4, remember(VOID, VOID, VOID, banners), hideWhenEmpty, animate);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.gg0_1 = function_0;
      }
      wi(a, b) {
        return this.gg0_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.gg0_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.hg0_1 = function_0;
      }
      wi(a, b) {
        return this.hg0_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.hg0_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function renderBanners$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.dg0_1;
  var tmp$ret$1 = b.dg0_1;
  return compareValues(tmp, tmp$ret$1);
}
function renderBanners$lambda_0($banner) {
  return ($this$dismissible) => {
    var tmp = notificationBar($this$dismissible, $banner.fg0());
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$dismissible.pc());
    var tmp0_elvis_lhs = $this$dismissible.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$dismissible : tmp0_elvis_lhs;
    $this$dismissible.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    html(view, ($this$html) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return $banner.eg0_1($this$html);
    });
    $this$dismissible.fbb(p, view);
    return $this$dismissible.jbb(tmp, view);
  };
}
function renderBannersNonDismissable$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.dg0_1;
  var tmp$ret$1 = b.dg0_1;
  return compareValues(tmp, tmp$ret$1);
}
function renderBannersNonDismissable$lambda_0($banner) {
  return ($this$html) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return $banner.eg0_1($this$html);
  };
}
function renderBanners$lambda_1(b) {
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = renderBanners$lambda$lambda;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0_1())(tmp);
  return sortedWith(b, tmp$ret$0);
}
var sam$kotlin_Comparator$0Class_1;
function sam$kotlin_Comparator$0_1() {
  if (sam$kotlin_Comparator$0Class_1 === VOID) {
    class $ {
      constructor(function_0) {
        this.ig0_1 = function_0;
      }
      wi(a, b) {
        return this.ig0_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ig0_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_1 = $;
  }
  return sam$kotlin_Comparator$0Class_1;
}
function renderBanners$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.dg0_1;
  var tmp$ret$1 = b.dg0_1;
  return compareValues(tmp, tmp$ret$1);
}
function renderBanners$lambda_2($this$forEachAnimated, it) {
  var handler = new (DismissibleHandler())(it.cg0_1);
  var tmp = _Constant___init__impl__v45mub(handler);
  return dismissible($this$forEachAnimated, new (Constant())(tmp), ($this$dismissible) => {
    var tmp = $this$dismissible.hbb(NotificationBarSemantic().lg0(it.fg0()));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$dismissible.pc());
    var tmp0_elvis_lhs = $this$dismissible.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$dismissible : tmp0_elvis_lhs;
    $this$dismissible.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    html(view, ($this$html) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return it.eg0_1($this$html);
    });
    $this$dismissible.fbb(p, view);
    return $this$dismissible.jbb(tmp, view);
  });
}
function renderBanners$lambda_3(it) {
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = renderBanners$lambda$lambda_0;
  var tmp$ret$0 = new (sam$kotlin_Comparator$0_1())(tmp);
  return sortedWith(it, tmp$ret$0);
}
function renderBanners$lambda$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.dg0_1;
  var tmp$ret$1 = b.dg0_1;
  return compareValues(tmp, tmp$ret$1);
}
function renderBanners$lambda_4($this$forEachUpdating, banner) {
  var handler = remember(VOID, VOID, VOID, ($this$remember) => new (DismissibleHandler())($this$remember.baj(banner).cg0_1));
  dismissible($this$forEachUpdating, handler, ($this$dismissible) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$dismissible.pc());
    var tmp0_elvis_lhs = $this$dismissible.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$dismissible : tmp0_elvis_lhs;
    $this$dismissible.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    dynamicTheme(view, ($this$dynamicTheme) => NotificationBarSemantic().lg0($this$dynamicTheme.baj(banner).fg0()));
    html(view, ($this$html) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return $this$html.baj(banner).eg0_1($this$html);
    });
    $this$dismissible.fbb(p, view);
    return view;
  });
  return Unit_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  banners as banners2ndq1wx79ibxx,
  renderBannersNonDismissable as renderBannersNonDismissable3209fu6o2rf9p,
  renderBanners_0 as renderBanners1vh1dpq8pq90j,
  renderBanners_1 as renderBannersqm0ix48feq51,
  renderBanners as renderBanners2vok7sjtj8k1c,
};
//endregion

//# sourceMappingURL=Banner.mjs.map
